import _ from 'underscore';
import { AdapterFactory, withValidation } from '@bingads-webui-react/validation';

const ValidationAdapter = AdapterFactory({
  defaultValue: {},
  valueToInject: 'data',
  functionToInject: 'onDataChange',
});

export const withValidationWrapper = _.partial(withValidation, _, ValidationAdapter);
